import { withRedux } from '@hoc/withRedux';
import { ReactComponent as SvgPin } from '@img/icons/pb-button-pin.svg';
import { pinboards } from '@redux/slices/pinboards';
import { retrievePinboards } from '@redux/slices/pinboards/actions/retrievePinboards';
import { DrawerMode } from '@redux/slices/pinboards/types';
import { useAppDispatch, useAppSelector } from '@redux/store';
import * as React from 'react';
import { FocusRing } from 'react-aria';
import S from './PinButton.styles';
const PinButton = (props) => {
    const dispatch = useAppDispatch();
    const boards = useAppSelector((state) => state.pinboards.items);
    React.useEffect(() => {
        loadPinboards();
    }, []);
    const activeBoards = React.useMemo(() => {
        const active = boards.map((board) => {
            const isActive = board.items.find((item) => {
                if (props.data.videoId) {
                    return props.data.videoId === item.videoId && props.data.url === item.url;
                }
                else if (props.data.image) {
                    return props.data.image.src === item.image?.src && props.data.url === item.url;
                }
                else {
                    return;
                }
            });
            return { id: board.id, item: isActive };
        });
        return active.filter((a) => a.item !== undefined);
    }, [boards, props.data.videoId, props.data.image]);
    return (React.createElement(FocusRing, { focusRingClass: "focus-ring" },
        React.createElement(S.Button, { title: `Pin${activeBoards.length > 0 ? ' or Unpin' : ''} This`, "data-active": activeBoards.length > 0, onClick: handleClick },
            React.createElement(SvgPin, null))));
    async function handleClick(event) {
        event.preventDefault();
        dispatch(pinboards.actions.showDrawer({
            mode: DrawerMode.CREATE_PINBOARD_ITEM,
            data: props.data,
            active: activeBoards,
        }));
    }
    async function loadPinboards() {
        dispatch(retrievePinboards());
    }
};
export default withRedux(PinButton);
